<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  mounted() {
    document.addEventListener('contextmenu', this.handleContextMenu);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('contextmenu', this.handleContextMenu);
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleContextMenu(e) {
      e.preventDefault();
    },
    handleKeydown(e) {
      if (
          e.key === 'F12' ||
          (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
          (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
      }
    },
  },
}
</script>

<style>

</style>
